import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Field, getMissingFields } from '../../services/requirements/requirements.model';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, map } from 'rxjs';


import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { ProfileFieldsComponent } from './profile-fields/profile-fields.component';
import { UserStore } from '../../stores/users.store';
import { toSignal } from '@angular/core/rxjs-interop';
import { UsersService } from '../../services/users/users.service';
import { RequirementsService } from '../../services/requirements/requirements.service';



@Component({
  selector: 'app-edit-profile',
  imports: [MatMenuModule, MatButtonModule, MatTooltipModule, MatFormFieldModule, MatInputModule, FormsModule, FaIconComponent, AvatarComponent, ProfileFieldsComponent],
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.css'
})
export class EditProfileComponent {

  readonly $users = inject(UsersService) ;
  readonly $requirements = inject(RequirementsService) ;
  readonly $route = inject(ActivatedRoute) ;
  readonly $router = inject(Router) ;
  readonly userStore = inject(UserStore) ;

  user = this.userStore.user ;
  loading = this.userStore.loading ;

  returnUrl = toSignal(
    this.$route.paramMap.pipe(
      map((params) => params.get("returnUrl"))
    )
  );

  requirements = toSignal(
    this.$requirements.getRequirementsFromReturnUrl(this.returnUrl())
  ) ;

  async save() {

    await firstValueFrom(this.$users.updateUser(this.user()!)) ;
    this.userStore.refreshUser();

    if (this.returnUrl())
      this.$router.navigateByUrl(this.returnUrl()!);
    else 
      this.$router.navigate(['/']) ;
  }

  takeSelfie() {

    let returnUrl = '/edit-profile';
    if (this.returnUrl)
      returnUrl = returnUrl + "?returnUrl=" + this.returnUrl ;

    this.$router.navigate(["/take-selfie"], {queryParams: {returnUrl}}) ;

  }

  deleteSelfie() {
    this.user()!.profileImage = undefined ;
  }


  get missingFields(): Field[] {
    if (!this.user() || !this.requirements()) {
      return [] ;
    }

    return getMissingFields(this.user()!, this.requirements()!) ;
  }


}
